import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import Box from '@tds/core-box';
import Select from '@tds/core-select';
import Button from '@tds/core-button';
import Notification from '@tds/core-notification';
import Spinner from '@tds/core-spinner';

import getStatusOptions from './utils';
import request from '../../../../../../utils/request';
import ProductConsoleId from './components/productConsoleId';
import ShippmentTrackingNumber from './components/shippmentTrackingNumber';
import ContractRecipient from './components/contractRecipient';
import { orderStatus as STATUS } from '../../../../../../utils/constant';
import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';

const OrderActions = ({ orderData }) => {
  const {
    ORDERS: { defaultOption, orderQuestion, save }
  } = useLocalizedStringsContext();

  const { id } = orderData;
  const [status, setStatus] = useState('');
  const [productConsoleId, setProductConsoleId] = useState();
  const [shippmentTrackingNumber, setShippmentTrackingNumber] = useState();
  const [contractRecipient, setContractRecipient] = useState({
    to: '',
    cc: ''
  });
  const [feedback, setFeedback] = useState({ message: '', variant: '' });
  const [loading, setLoading] = useState(false);

  const onStatusChange = e => {
    setStatus(e.target.value);
  };

  const onUpdateStatus = async () => {
    try {
      setLoading(true);
      const payload = { status };
      if (productConsoleId) payload.iotProductConsoleOrderId = productConsoleId;
      if (shippmentTrackingNumber)
        payload.iotShippmentTrackingNumber = shippmentTrackingNumber;
      if (contractRecipient.to) payload.contractEmail = contractRecipient.to;
      if (contractRecipient.cc) payload.contractEmailCC = contractRecipient.cc;
      if (status === STATUS.contractSent) payload.isContractResend = false;

      const result = await request.put(`/orders/${id}`, payload);
      if (result)
        setFeedback({
          message: `Status updated to ${status} successfully`,
          variant: 'success'
        });
      setLoading(false);
      setStatus('');
    } catch (err) {
      setFeedback({
        message: 'Error occoured while updating the status',
        variant: 'error'
      });
      setLoading(false);
      setStatus('');
    }
  };

  useEffect(() => {
    const { email_signingAuthority: signingAuthorityEmail } = orderData;
    setContractRecipient({
      ...contractRecipient,
      to: signingAuthorityEmail
    });
  }, [orderData]);

  return (
    <Box between={4}>
      {feedback.message && (
        <Notification
          variant={feedback.variant}
          dismissible
          onExit={() => setFeedback({ message: '', variant: '' })}
          copy="en"
        >
          {feedback.message}
        </Notification>
      )}
      <Select
        label={orderQuestion}
        placeholder={defaultOption}
        options={getStatusOptions(orderData)}
        value={status}
        onChange={onStatusChange}
      />
      {status === STATUS.orderPlaced && (
        <ProductConsoleId
          productConsoleId={productConsoleId}
          setProductConsoleId={setProductConsoleId}
        />
      )}
      {status === STATUS.orderShipped && (
        <ShippmentTrackingNumber
          shippmentTrackingNumber={shippmentTrackingNumber}
          setShippmentTrackingNumber={setShippmentTrackingNumber}
        />
      )}
      {status === STATUS.contractSent && (
        <ContractRecipient
          contractRecipient={contractRecipient}
          setContractRecipient={setContractRecipient}
        />
      )}

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Spinner label="Updating..." size="small" spinning={loading} inline>
          <Button variant="secondary" onClick={onUpdateStatus}>
            {save}
          </Button>
        </Spinner>
      </div>
    </Box>
  );
};

OrderActions.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired
};

export default OrderActions;
